<template>
	<common-card
		class="omapi-campaign-settings__publish"
		contentClass="omapi-card__border"
	>
		<template v-slot:title>Visibility &amp; Status</template>
		<div class="omapi-campaign-settings__minor-publishing">
			<slot/>
		</div>

		<template v-slot:footer>
			<em
				class="saving-status"
				:class="{'saving-status-disabled': disabled}"
			>Saving disabled.</em>
			<core-save-button
				color="green"
				:disabled="!changed || disabled"
				:saving="saving"
			/>
		</template>

	</common-card>
</template>

<script lang="js">
export default  {
	props : {
		changed  : Boolean,
		saving   : Boolean,
		disabled : Boolean,
	},
}
</script>
<style scoped>
	.saving-status {
		visibility: hidden;
	}
	.saving-status.saving-status-disabled {
		visibility: visible;
	}
</style>
